module.exports = __webpack_public_path__ + "img/front rise.12a1a41f.png";